import React from "react";
import {
  Box,
  ButtonGroup,
  Container,
  HStack,
  Text,
  Button,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { useLocation, Link as RouterLink } from "react-router-dom";

import { Logo } from "./Logo";
import { MobileDrawer } from "./MobileDrawer";
import { NavButton } from "./NavButton";
import { groupAlerts } from "../../utils/forecasts";
import useForecasts from "../customHooks/useForecasts";
import useRegions from "../customHooks/useRegions";
import { BackButton } from "./BackButton";

const Header = (props) => {
  const { links } = props;
  const forecasts = useForecasts();
  const regions = useRegions();
  const location = useLocation();

  const allForecasts = forecasts?.map((query) => query?.data).flatMap(query => query?.forecasts);
  const groupedAlerts = groupAlerts(allForecasts, regions?.data?.regions);
  const alertCount = groupedAlerts.length;

  const isHomePage = location.pathname === '/';

  return (
    <Box
      bg="#00838A"
      position="relative"
      style={{
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
        zIndex: 99,
      }}
      zIndex="docked"
    >
      <Container py="3">
        <HStack justify="space-between" spacing="8">
          <HStack spacing="10">
            <HStack spacing="3">
              <RouterLink to='/'>
                <Logo />
                <h1
                  style={{
                    color: 'white',
                    fontSize: 11,
                  }}
                >
                  Mariner's Dashboard
                </h1>
              </RouterLink>
            </HStack>
            <ButtonGroup
              size="lg"
              variant="ghost"
              colorScheme="white"
              spacing="8"
              display={{
                base: "none",
                lg: "flex",
              }}
            >
              {links.map((link) => (
                <NavButton
                  key={link.title}
                  title={link.title}
                  path={link.path}
                  color='white'
                />
              ))}
            </ButtonGroup>
          </HStack>
          <HStack
            spacing={{
              base: "2",
              md: "4",
            }}
          >
            <ButtonGroup variant="tertiary" spacing="1">
              <Button
                as={ RouterLink }
                to={'/alerts'}
                bg="teal.500"
                p={3}
              >
                <Box mr={1}>
                  <Text px={2} color="teal.500" bg="white" fontWeight={700} fontSize={16} borderRadius={3}>!</Text>
                </Box>
                <Text color="white" fontWeight={600}>{alertCount}</Text>
              </Button>
            </ButtonGroup>
            <MobileDrawer links={links} />
          </HStack>
        </HStack>
      </Container>
      {!isHomePage && (
        <BackButton />
      )}
    </Box>
  );
};

Header.propTypes = {
  links: PropTypes.array,
};

Header.defaultProps = {
  links: [],
};

export { Header };
